/**
 * React hook to handle the dark/light mode of the theme
 */

import {
  useEffect, useState,
} from 'react';

import Cookies from 'universal-cookie';

import { getCurrentUserId } from '../../../services/auth';
import { useGetCurrentUserQuery } from '../../../services/users';
import { ThemeMode } from '../../../theme';
import { THEME_MODE_SWITCH_KEY } from '../../common/constants';

const cookies = new Cookies();

const useDarkMode = (isDarkMode: boolean) => {
  const userId = getCurrentUserId();
  const [darkMode, setDarkMode] = useState<boolean>(isDarkMode);

  const { data: currUser } = useGetCurrentUserQuery();

  const initDarkMode = () => {
    setDarkMode(true);
    cookies.set(THEME_MODE_SWITCH_KEY, ThemeMode.Dark, { path: '/' });
  };

  const initLightMode = () => {
    setDarkMode(false);
    cookies.set(THEME_MODE_SWITCH_KEY, ThemeMode.Light, { path: '/' });
  };

  const useFallbackThemeMode = () => {
    setDarkMode(isDarkMode);
  };

  useEffect(() => {
    if (userId) {
      if (currUser?.data.settings?.themeMode === ThemeMode.Dark) initDarkMode();
      else if (currUser?.data.settings?.themeMode === ThemeMode.Light) initLightMode();
      else useFallbackThemeMode();
    } else useFallbackThemeMode();
  }, [currUser]);

  return {
    darkMode, initLightMode, initDarkMode,
  };
};

export default useDarkMode;
